import React from "react";
import "./menuHeader.css";
import search from "../../../../Assets/search.svg";
import { getRestaurantName } from "../../../../auth/AuthHandler";

const MenuHeader = ({ searchQuery, handleSearchChange, onBack }) => {
  const restaurantName = getRestaurantName();

  return (
    <header className="Menu-header">
      <button className="header-back-btn" onClick={onBack}>
          Back To Restaurants
        </button>
      <div className="heading-text">
        <h1>Menu Management - {restaurantName}</h1>
      </div>
      <div className="heading-profile">
        <div className="search-bar">
          <input
            type="text"
            placeholder="Search Dish"
            value={searchQuery}
            onChange={handleSearchChange}
          />
        </div>
      </div>
    </header>
  );
};

export default MenuHeader;
